(() => {
  const callback = async () => {
    const selectors = {
      head: 'head',
      chatContainer: '#gorgias-chat-container',
      chatButton: '#chat-button',
    };

    const initializeGorgiasChat = () => {
      if (window.GorgiasChat) return Promise.resolve();

      return new Promise((resolve) => window.addEventListener('gorgias-widget-loaded', resolve));
    };

    const hideDefaultChatButton = () => {
      const timer = setInterval(() => {
        const chatContainer = document.querySelector(selectors.chatContainer);
        const chatButtonIframe = chatContainer?.querySelector(selectors.chatButton);
        const chatButtonHead = chatButtonIframe?.contentWindow?.document?.querySelector(selectors.head);

        if (!chatButtonHead || !chatButtonHead.children.length) return;

        clearInterval(timer);

        if (chatButtonIframe) chatButtonIframe.style.display = 'none';
      }, 50);
    };

    const createCustomChatButton = () => {
      const customButton = document.createElement('button');
      customButton.className = 'gorgias__chat-button';
      customButton.innerHTML = `
        <div class="gorgias__chat-button-icon">
          <img
            src="https://cdn.shopify.com/s/files/1/0496/9427/7797/files/understatement-symbol-black.png?v=1736536081"
            width="21"
            height="24"
            alt=""
          >

          <svg fill="none" width="22" height="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="img">
            <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0l-4.89 4.88-4.89-4.89c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l4.89 4.89-4.89 4.89c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l4.89-4.89 4.89 4.89c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41l-4.89-4.89 4.89-4.89c.38-.38.38-1.02 0-1.4z" fill="#161616"></path>
          </svg>
        </div>

        <span>${window.theme.strings.gorgiasChatButtonLabel || 'Chat'}</span>
      `;

      customButton.addEventListener('click', () => {
        const isChatOpen = window.GorgiasChat.isOpen();

        customButton.classList.toggle('active', !isChatOpen);
        isChatOpen ? window.GorgiasChat.close() : window.GorgiasChat.open();
      });

      document.body.appendChild(customButton);
    };

    try {
      await initializeGorgiasChat();
      hideDefaultChatButton();
      createCustomChatButton();
    } catch (error) {
      console.error(error);
    }
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
